// local
import {
  TRENDS,
  STATE_URL,
  GEOGRAPHY_URL,
  PRESIDENT,
  US_PRES,
} from './constants.js';

// packages
import { get } from 'svelte/store';
import {
  createFeed,
  createRaceFeed,
  createCandidateLookup,
  createSubunitLookup,
} from './stores.js';
import { json } from 'd3-fetch';
import { topojsonToGeoJson } from './utils/geography.js';

import {
  renderSvelteComponent,
  findSvelteComponentContainer,
  findSvelteComponentContainers,
} from './utils/render.js';

// components
import BarChart from './components/BarChart.svelte';
import Results from './components/Results.svelte';
import ResultsMap from './components/ResultsMap.svelte';
import ResultsLegend from './components/ResultsLegend.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  const stateFeed = await createFeed(STATE_URL);
  const nationalFeed = await createFeed(US_PRES);
  const presFeed = await createFeed(PRESIDENT); // has to be changed later from presFeed

  const presResults = findSvelteComponentContainer('#pres-results');
  const presResultsTable = findSvelteComponentContainer(
    '#pres-ca-results-table'
  );
  const presResultsMap = findSvelteComponentContainer('#results-map-pres');
  const presResultsLegend = findSvelteComponentContainer(
    '#results-legend-pres'
  );

  const presidentRaceFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createRaceFeed(stateFeed, 'CA-P0-2024-11-05')
  );

  if (presResults) {
    renderSvelteComponent(BarChart, /** @type {HTMLElement} */ presResults, {
      feed: presidentRaceFeed,
      face: true,
      numOfCandidates: 2,
      crosswalk,
    });
  }

  if (presResultsTable) {
    renderSvelteComponent(
      Results,
      /** @type {HTMLElement} */ presResultsTable,
      {
        feed: presidentRaceFeed,
        national: nationalFeed,
        face: false,
        crosswalk,
      }
    );
  }

  if (presResultsMap) {
    // map data
    const topology = await json(GEOGRAPHY_URL);
    const [geography, roads, cities] = topojsonToGeoJson(topology, [
      'counties',
      'roads',
      'cities',
    ]);

    const presRaceCandidateLookup = createCandidateLookup(presidentRaceFeed);
    const presRaceSubunitLookup = createSubunitLookup(presidentRaceFeed);

    ////MAP
    renderSvelteComponent(
      ResultsMap,
      /** @type {HTMLElement} */ presResultsMap,
      {
        geography,
        roads,
        cities,
        candidates: presRaceCandidateLookup,
        subunits: presRaceSubunitLookup,
        includeParty: true,
        feed: presidentRaceFeed,
      }
    );
    renderSvelteComponent(
      ResultsLegend,
      /** @type {HTMLElement} */ presResultsLegend,
      {
        race: presidentRaceFeed,
      }
    );
  }
}

main().catch(console.error);
